import React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import { Outlet } from "react-router-dom";
import AccountSection from "../AccountSection/AccountSection";

export default function NavBar() {
    const darkBlue = '#545a86';
    const blue = '#1d8abf';
    const teal = '#3bb7b2';

    const gradient = {
        backgroundImage: `linear-gradient(to right, ${darkBlue}, ${blue}, ${teal})`
    };

    return (
        <Box display="flex" flexDirection="column" height="100vh">
            <AppBar position="static" sx={gradient}>
                <Toolbar variant="dense" sx={{ my: -1 }}>
                    {/*<img src="/ResQ-Logo-White-NoTagline.png" height="30px" style={{ marginRight: "20px" }} />*/}
                    {/*<Typography variant="h5">iQ</Typography>*/}
                    <img src="/iQLogo.png" height="42px" style={{ marginRight: "20px" }} />
                    <div style={{ flexGrow: 1 }} />
                    <AccountSection />
                </Toolbar>
            </AppBar>
            <Box overflow="hidden" flexGrow={1}>
                <Outlet />
            </Box>
        </Box >
    );
}